import { generateDoorMap } from "../formulas/formula-helpers";
import { ValueGetterParams } from "ag-grid-community";
import { DIMENSION_IDS_DELIMITER } from "epics/collections";
import { MetricsKind } from "../types";

export const STORE_WITH_UNITS = ({ factoryOptions, getterParams }) => {
    const { deliveryId, doors } = factoryOptions;
    const {
        data: { reviewPlan },
    }: ValueGetterParams = getterParams;

    const doorsMap = generateDoorMap(doors);
    const doorsWithUnits = new Set();

    Object.keys(reviewPlan).forEach((key) => {
        const reviewPlanItem = reviewPlan[key].struct_value;
        const tokens = key.split(DIMENSION_IDS_DELIMITER);
        let doorKey;
        let deliveryKey;

        if (tokens.length === 3) {
            doorKey = tokens[0];
            deliveryKey = tokens[2];
        } else if (tokens.length > 0) {
            doorKey = tokens[0];
        }

        // Find metric for this item
        if (reviewPlanItem.metrics) {
            for (const metric of reviewPlanItem.metrics) {
                if (metric.kind === MetricsKind.UNITS) {
                    const metricValue = metric.value?.number_value ?? 0;
                    if (deliveryId && deliveryId === deliveryKey && doorsMap.has(doorKey)) {
                        if (metricValue > 0) {
                            doorsWithUnits.add(doorKey);
                        }
                    } else if (!deliveryId && doorsMap.has(doorKey)) {
                        if (metricValue > 0) {
                            doorsWithUnits.add(doorKey);
                        }
                    }
                    break;
                }
            }
        }
    });

    return doorsWithUnits.size;
};
